import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ArtikelAttributeServiceConfig = {
  name: "ArtikelAttribute",
  annotations: []
} as ServiceConfig;